import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig, FormlyModule } from "@ngx-formly/core";
import { TranslateModule } from "@ngx-translate/core";

/**
 * Custom Formly field type for text inputs.
 *
 * Usage:
 * ```typescript
 * {
 *   key: 'name',
 *   type: 'form-input',
 *   props: {
 *     label: 'Name',
 *     inputType: 'text', // 'text', 'email', 'url', 'number', etc.
 *     placeholder: 'Enter name...',
 *     required: true
 *   }
 * }
 * ```
 */
@Component({
  selector: "app-formly-form-input",
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, FormlyModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class]="props['formGroupClass'] || 'form-group'">
      @if (props.label) {
      <label [attr.for]="id">{{ props.label | translate }}</label>
      }
      <input
        [type]="props['inputType'] || 'text'"
        class="form-control"
        [id]="id"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [placeholder]="props.placeholder || '' | translate"
      />
    </div>
  `,
})
export class FormInputFieldComponent extends FieldType<FieldTypeConfig> {
  override defaultOptions = {
    props: {
      inputType: "text",
      placeholder: "",
    },
  };
}
